
<h2>{{header}}</h2>
<mat-dialog-content>
  <div class="form-group">
    <label>Enter reason</label>
    <textarea class="form-control"  [(ngModel)]="reason" [placeholder]="reasonPlaceholder">

    </textarea>
  </div>

</mat-dialog-content>

<div class="dialog-buttons"  >
  <div style="display:flex" >
    @if (data.approve) {
      <button [disabled]="!reason" (click)="approve()" class="btn btn-primary btn-round btn-round-sm" >
        <i class="fa fa-thumbs-up"></i>
        <div style="font-weight:normal" >approve</div>
      </button>
    }
    @if (data.reject) {
      <button [disabled]="!reason"  (click)="reject()" class="btn btn-primary btn-round btn-round-sm" >
        <i class="fa fa-thumbs-down"></i>
        <div  style="font-weight:normal">reject</div>
      </button>
    }
    <div style="flex-grow: 1"></div>
    <button (click)="close()" class="btn btn-primary btn-round btn-round-sm" >
      <i class="fa fa-close"></i>
      <div  style="font-weight:normal" >cancel</div>
    </button>

  </div>

</div>